/** 목록 행에 표시하는 알약형 완성도 뱃지 */
export function CompletionBadge({ pct, className = "" }: { pct: number; className?: string }) {
  const color =
    pct === 100
      ? "bg-green-100 text-green-700"
      : pct > 0
      ? "bg-amber-100 text-amber-700"
      : "bg-gray-100 text-gray-400";
  return (
    <span className={`rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${color} ${className}`}>
      {pct}%
    </span>
  );
}

/** 인라인 텍스트 형식의 완성도 표시 (편집 화면 항목 내) */
export function InlineCompletion({ pct }: { pct: number }) {
  const color =
    pct === 100 ? "text-green-500" : pct > 0 ? "text-amber-500" : "text-gray-400";
  return <span className={`text-[10px] font-semibold ${color}`}>{pct}%</span>;
}
